"use strict";

(function(z){

    z.TransferMaterialForm = z.FormView.extend({
        el:"transfer-materials-page",

        events: function() {

            return _.extend({}, z.FormView.prototype.events,{
                "click #transferMaterialform-save-button": "_onSubmitForm",
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {

            // z.FormView.prototype.initialize.apply(this, arguments);
        },

        /**
         * Method that renders the form
         *
         * @return {Object} - this object
         */
        render: function() {

            // Clean up the form
            this._cleanupForm();

            z.FormView.prototype.render.apply(this, arguments);

            // Initialize the chosen fields
            // this._initializeChosen();

            var title = this.getModalFormEditTitleText();

            if (this.$el.find('.modal-title').text() === title) {

                this.$el.find("#materialform-partNumber-field").prop("disabled", true);
                this.$el.find("#materialform-type-field").prop("disabled", true);
            } else {

                this.$el.find("#materialform-partNumber-field").prop("disabled", false);
                this.$el.find("#materialform-type-field").prop("disabled", false);
            }


            return this;
        },

        /**
         * Get add entity route name.
         *
         * @return {string} - add entity route name
         */
        getAddEntityRouteName: function() {
            return 'addMaterial';
        },

        /**
         * Get edit entity route name.
         *
         * @return {string} - edit entity route name
         */
        getEditEntityRouteName: function() {
            return 'editMaterial';
        },

        /**
         * Get modal form add title text
         *
         * @return {string} - modal form add title text
         */
        getModalFormAddTitleText: function() {
            return Translator.trans('js.btn_add_material');
        },

        /**
         * Get modal form edit title text
         *
         * @return {string} - modal form edit title text
         */
        getModalFormEditTitleText: function() {
            return Translator.trans('js.btn_edit_material');
        },

        /**
         * Get error panel container id.
         *
         * @return {string} - the error panel id
         */
        getErrorPanelId: function() {
            return '#materialform-error-panel';
        },

        /**
         * Get submit button selector.
         *
         * @return {string} - the submit button selector
         */
        getSubmitButtonSelector: function() {
            return '#materialform-save-button';
        },

        /**
         * Get page path.
         *
         * @return {string} - the page path
         */
        getPagePath: function() {
            return 'material';
        },

        /**
         * Get success event name.
         *
         * @return {string} - the success event name
         */
        getSuccessEventName: function() {
            return 'material.success';
        },

        /**
         * Get form error message text.
         *
         * @return {string} - form error message text
         */
        getFormErrorMessageText: function() {
            return Translator.trans('js.error_message_materialform');
        },


        /**
         * Collecting data from form inputs.
         *
         * @private
         * @return {Object} {{name: *, sapMaterialNumber: *, price: *}}
         */
        getFormData: function() {

            // Get the fields
            var $nameField     = this.$('#materialform-name-field');
            // var $sapIdField   = 'hardcodeddump';// this.$('#extraservicesform-sapId-field');
            var $partNumberField   = this.$('#materialform-partNumber-field');
            var $partTypeField   = this.$('#materialform-type-field');
            var $aquisitionPriceField   = this.$('#materialform-aquisitionPrice-field');
            var $commodityCodeField   = this.$('#materialform-commodityCode-field');
            var $locationField   = this.$('#materialform-location-field');
            var $statusField   = this.$('#materialform-status-field');

            return {
                'name'     : $nameField.val(),
                // 'sapMaterialNumber'   : $sapIdField.val(),
                'categoryId'   : "1534",// 1534 pentru PROD
                'type'   : $partTypeField.val(),
                'partNumber'   : $partNumberField.val(),
                'aquisitionPrice'   : $aquisitionPriceField.val(),
                'commodityCode'   : $commodityCodeField.val(),
                'location'   : $locationField.val(),
                'status'   : $statusField.val()
            };
        },

        /**
         * Method used to show a general error message if the user is
         * browsing the app on mobile
         *
         * @return {undefined}
         */
        showMobileAlert: function()
        {
            var errorMessage = Translator.trans('js.material_create_error_message_mobile');

            // Display mobile alert
            this.$el.find('#material-create-general-error-panel')
                .removeClass('hidden')
                .text(errorMessage)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
        },

        /**
         * Method used to hide the error message if the form is submitted, or the modal has been closed
         *
         * @return {undefined}
         */
        hideMobileAlert: function()
        {
            this.$el.find('#material-create-general-error-panel').addClass('hidden');
        },

        /**
         * Method that resets the form fields, resets the collections and
         * hides the tables holding data
         *
         * @private
         * @return {undefined}
         */
        _cleanupForm: function() {

            // Resetting form
            this._resetFields("materialform");
        },

        /**
         * Method that hides the wrapper that holds the table
         *
         * @param {Object} $wrapperName - the div object that acts as a wrapper
         * @private
         * @return {undefined}
         */
        _hideWrapper: function($wrapperName) {

            $wrapperName.addClass("hidden");
        },


        /**
         * Method that resets the specified fields according to id passed
         *
         * @param {string} value Name of the id to search for
         * @private
         * @return {undefined}
         */
        _resetFields: function (value) {

            this.$('[id^=' + value + ']').val("");
        },


        /**
         * Method that fills the form input fields with data coming from the model.
         * It is used when the form is being edited.
         *
         * @private
         * @return {undefined}
         */
        _fillForm: function() {

            var map = {
                "materialform-name-field": "name",
                "materialform-sapId-field": "sapId",
                "materialform-type-field": "type",
                "materialform-category-field": "category",
                "materialform-partNumber-field": "partNumber",
                "materialform-commodityCode-field": "commodityCode",
                "materialform-location-field": "location",
                "materialform-status-field": "status",
                "materialform-aquisitionPrice-field": "aquisitionPrice"
            };

            Object.keys(map).forEach(function(key){

                this.$el.find("#"+key).val(this.model.get(map[key]));

                var value = this.model.get(map[key]);
                switch (key) {

                    case "materialform-status-field":
                        if (value === true || value === 1) {
                            this.$("#" + key).val("1");
                        } else if(value === false || value === 0) {
                            this.$("#" + key).val("0");
                        } else {
                            this.$("#" + key).val("1");
                        }
                        break;

                    case "materialform-aquisitionPrice-field":

                        if (typeof value === 'undefined') {

                            this.$el.find("#" + key).val(0);
                        } else {

                            this.$el.find("#" + key).val(value);
                        }
                        break;

                    default:
                        this.$el.find("#" + key).val(value);
                }

            }.bind(this));
        },

        /**
         * Method that binds validation to the chosen model
         *
         * @param {object} model The model that the validation is being performend on
         * @private
         * @return {undefined}
         */
        _bindValidation: function(model) {

            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});

            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        /**
         * Display the error message
         *
         * @param {string} message The message to be shown
         * @private
         * @return {undefined}
         */
        _showError: function(message) {
            // TODO: move in abstract class to be reused

            var errorMessage = Translator.trans('js.material_create_error_message_mobile');

            // Display mobile alert
            this.$el.find('#material-create-general-error-panel')
                .removeClass('hidden')
                .text(message)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
            // this._isLoading(false);
            //
            // var $error = this._getInformationPanel();
            // $error
            //     .removeClass('hidden alert-success')
            //     .addClass('alert-danger')
            //     .text(message)
            //     .fadeTo('slow', 1)
            //     .delay(5000);
        },

        _displayError: function(res){
            console.log(res.responseJSON);
            var errors = res.responseJSON.errors;

            if (errors.length !== 0) {

                var message = errors;

                if (typeof res.responseJSON != "undefined")
                {
                    this._showError(message);
                }
            }
            // this._resetForm();
        },

        /**
         * Method that handles the form submission
         *
         * @param {Event} e - the event
         * @return {undefined}
         * @private
         */
        _onSubmitForm: function (e) {

            e.preventDefault();

            // Get form data
            var formData = this.getFormData();
            this.model.set(formData);

            var isValid = this.model.isValid(true);

            if( !isValid ){
                this.showMobileAlert();
                return;
            }

            this._isLoading(true, this.getSubmitButtonSelector());

            // Save the material
            this.model.save(null, {

                success: function (i) {

                    this.model.trigger("success", i);
                }.bind(this),
                error: function(model, res) {

                    if (res == "Commodity code not found in SAP")
                    {
                        res = "Commodity codul introdus nu există în lista de coduri valide."
                    }
                    // Showing error messages
                    this._displayError(res);
                    this._isLoading(false, this.getSubmitButtonSelector());

                }.bind(this)
            });
        },
    });

})(window.z = window.z || {});
